<template>
  <v-card
    outlined
    flat
  >
    <draggable
      style="border: 1px"
      class="list-group"
      group="judges"
      :list="chairList"
      :move="chairDragged"
      @change="chairChanged"
    >
      <v-card-title v-if="chair != null">
        {{ chair }}
      </v-card-title>
      <button
        v-if="chair == null"
        slot="header"
      >
        <v-card-title class="dashed-border text--secondary ma-3 text-center">
          Drop a Judge here
        </v-card-title>
      </button>
    </draggable>
  </v-card>
</template>


<script>
import draggable from 'vuedraggable'
import {TableDesignerTable} from "@/types/table-designer/table";

export default {
  name: "TableDesignerTableCard",
  components: {draggable},
  props: {
    table: {type: TableDesignerTable, required: true, default: null}
  },
  data: () => ({
  }),
  computed: {
    chairList:{
      get() {
        return [this.table.chair];
      },
      set(value) {
        console.log("setting", value);
        this.$emit("chairChanged", value);
      }
    },
    chair() {
        return this.table.chair;
    },
  },
  mounted() {
    var a = 1;
  },
  methods: {
    chairChanged(e) {
      console.log("chairChanged", e)
      this.$emit("chairChanged", e.added.element);
    },
    chairDragged(e) {
      console.log("chairDragged", e)
    }
  },
}
</script>

<style scoped>
  .dashed-border {
    border-style: dashed;
    border-width: medium;
  }
</style>